var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center border gap-[5px] rounded-[4px] font-[600] text-dark !text-[11px] h-[29px] px-[18px] shadow-[0_2px_3px_rgba(0, 0, 0, 0.06)] mb-[25px]",attrs:{"disabled":_vm.loading},on:{"click":_vm.addItem}},[_vm._v(" Add List Item "),_c('span',{staticClass:"text-[#3D82EA] text-[20px]"},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }